var AuthService = (function AuthService(){
	'use strict';

	return {
		init: init
	};

	function init (){
		setAccessToken();
	}
	
	function setAccessToken() {
		$.ajax({
			url: '/app/',
			dataType: 'json',
			type: 'POST',
			cache: false,
			data: {
				module: 'utility.getIP',
				method: 'GET'
      }
    }).done(function successToken (response, textStatus, jqXHR) {
        StorageService.sessionStorage.setItem('accessToken', response.token);
    });
	}

})();

Object.freeze(AuthService);
